// src/axiosInstance.js
import axios from 'axios';
import { continueToken } from './App';

const axiosInstance=axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
// Request interceptor
axiosInstance.interceptors.request.use(



  (config) => {
    // Modify the config to include your custom headers
    const token = sessionStorage.getItem('accessToken'); 
    if (token) {
      config.headers['authorizationToken'] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


const isTokenExpaired = (token) =>{
   if(!token) return true

   try{
     const [, payload] = token.split(".")
     const decoded = JSON.parse(atob(payload))
     const expiry = decoded.exp * 1000
       return expiry < Date.now()
   }catch(error){
   console.error("Invalid Token:",error)
    return true
   }
}

 // if(isTokenExpaired(refreshToken)){
      //   console.log("refreshToken expired")
      //   sessionStorage.removeItem("refreshToken")
      //   window.dispatchEvent(
      //     new CustomEvent("refreshTokenExpired", {
      //       detail: { errorMessage: "Your session has expired. Please log in again." },
      //     })
      //   );
      // }


// Response interceptor (optional)
// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     console.log(error,"errrormessages");
    
//     // Handle errors globally
//     if(error.response && (error.response.status===401 && error.response.data.message=="Unauthorized" || error.response.status===403)){
//       let errorMessage='';
//       if(error.response.status===401 && error.response.data.message){
//         errorMessage='Please login again.'
//       }else if(error.response.status===403){
//         errorMessage='You do not have permission to access this resource'
//       }
//       window.dispatchEvent(new CustomEvent('tokenExpired', {detail:{errorMessage}}));
//     }else if(error.response.data.permissions){
//       let errorMessage='';
//       errorMessage=error.response.data.permissions;
//       window.dispatchEvent(new CustomEvent('tokenExpired', {detail:{errorMessage}}));
//     }
//     return Promise.reject(error);
//   }
// );

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     console.log(error, "error messages");

//     if (error.response) {
//       const status = error.response.status;
//       const errorMessage = error.response.data?.message;
//       // const refreshToken = sessionStorage.getItem("refreshToken")

     
      
//       if (status === 401 && errorMessage === "Unauthorized" || error.response.status===403) {
//         window.dispatchEvent(
//           new CustomEvent("tokenExpired", {
//             detail: { errorMessage: "Access token expired. Refreshing..." },
//           })
//         );
//       } 
      
     
//       else if (status === 403 && errorMessage === "Refresh token expired") {
//         sessionStorage.removeItem("refreshToken");
//         window.dispatchEvent(
//           new CustomEvent("refreshTokenExpired", {
//             detail: { errorMessage: "Your session has expired. Please log in again." },
//           })
//         );
//       }

//       // Handle Permission Errors

//       else if (status === 403) {
//         const isRefreshTokenInvalid = !sessionStorage.getItem("refreshToken"); 
//         const eventType = isRefreshTokenInvalid ? "refreshTokenExpired" : "tokenExpired";
//         const errorMessage = isRefreshTokenInvalid 
//           ? "Your session has expired. Please log in again." 
//           : "You do not have permission to access this resource.";
      
//         window.dispatchEvent(new CustomEvent(eventType, { detail: { errorMessage } }));
//       }

//       // Handle Custom Permission Errors

//       else if (error.response.data.permissions) {
//         let errorMessage = error.response.data.permissions;
//         window.dispatchEvent(new CustomEvent("tokenExpired", { detail: { errorMessage } }));
//       }
//     }

//     return Promise.reject(error);
//   }
// );

let isRefreshing = false;
let failedRequestsQueue = [];

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error, "error messages");

    if (error.response) {
      const status = error.response.status;
      const errorMessage = error.response.data?.message;

      // Handle Unauthorized (401) or Forbidden (403) errors
      if (status === 401 || status === 403) {
        const originalRequest = error.config;
        const hasTokenFailed = sessionStorage.getItem("hasTokenFailed") === true
        if(hasTokenFailed){
          console.log("Token refersh already failed, not retrying...")
          return Promise.reject(error)
        }

        if (!isRefreshing) {
          isRefreshing = true;
          window.dispatchEvent(
            new CustomEvent("tokenExpired", {
              detail: { errorMessage: "Please log in again."},
            })
          );

          return continueToken().then((newAccessToken) => {
            isRefreshing = false;
            if(!newAccessToken){
              console.log("No new access token reacived")
              sessionStorage.setItem("hasTokenFailed", "true")
              return Promise.reject(error)
            }

            // Retry all failed requests with the new access token
            failedRequestsQueue.forEach((cb) => cb(newAccessToken));
            failedRequestsQueue = [];

            originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            return axiosInstance(originalRequest);
          }).catch(() => {
            isRefreshing = false;
            failedRequestsQueue = [];
            return Promise.reject(error);
          });
        }

        // Queue failed requests until the token refresh is done
        return new Promise((resolve) => {
          failedRequestsQueue.push((newAccessToken) => {
            originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
